// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body {
  position: fixed;      /* lock body in viewport */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;     /* no x or y scroll */
  display: flex;        /* flexbox layout */
}



.page-content {
  display: flex;
  height: 100%;
  width: 100%;
  flex: 1 1;
  background: black;
  overflow-x: hidden;
  overflow-y: hidden;
}

.report-type-dropdown-container {
  display: flex;
  height: 100px;
  width: 100%;
  flex: 1 1;
  background: black;
}



.cornerstone-container {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  background: black;
  height: 100%;
}

.clientcornerstone-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: black;
  height: 100%;
}

.viewer-panel {
  width: 100%;
  margin:1px;
}


.viewport-div {
  display: grid;           /* Grid container for all layouts */
  width: 100%;
  height: 90vh !important;
  gap: 2px;                /* Optional space between viewports */
  margin: 0.5em auto auto;
  grid-auto-flow: row; /* ensures items fill rows first */
}



  #viewport2{
    display: none;
  }
  
  #viewport3{
    display: none;
  }
  
  #viewport4{
    display: none;
  }

  .viewport {
    width:auto;
    height: 100%;
    border: 2px solid red;
    box-sizing: border-box;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    background-color: black;
    margin: 1px;
  }
  
  .cornerstone-canvas {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    width: auto !important;
    height: auto !important;
    pointer-events: none;
  }
.viewer-sidebar {
  max-width: 320px;
  min-width: 150px;
  background-color: #1D1D1F;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 100%;
  overflow: hidden;
  color: white;
   flex-shrink: 0;
}

.viewer-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.white-text { color: white; }
.red-text { color: #F87171; }

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.user-avatar {
  background-color: #6466F1;
  border-radius: 9999px;
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-name {
  font-size: 0.875rem;
  font-weight: 600;
}

.user-mrn {
  font-size: 0.75rem;
  color: #9CA3AF;
}

.user-detail {
  font-size: 0.75rem;
  color: #9CA3AF;
  margin-bottom: 0.2rem;
}

.history-notes {
  max-height: 300px;      /* optional: minimum height if you want */
  overflow-y: auto;        /* vertical scroll if content exceeds */
  padding: 8px;
  border: 1px solid #ddd;  /* optional border */
  border-radius: 4px;
  background-color: #2A2A2E;
}

/* Optional: smooth scroll for better UX */
.history-notes::-webkit-scrollbar {
  width: 6px;
}

.history-notes::-webkit-scrollbar-thumb {
  background-color: #6466F1;
  border-radius: 3px;
}


.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.history-count {
  background-color: #F87171;
  font-size: 0.75rem;
  padding: 2px 8px;
  border-radius: 9999px;
  color: white;
}

.history-content {
  background-color: #2A2A2E;
  padding: 8px;
  font-size: 0.7rem;
  border-radius: 4px;
  color: #D1D5DB;
}

.history-date {
  text-transform: uppercase;
  color: #9CA3AF;
  margin-bottom: 2px;
}

.history-doctor {
  color: #9CA3AF;
}

.history-text {
  margin-top: 0.5rem;
  color: white;
}

.images-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.images-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.images-count {
  background-color: #F87171;
  font-size: 0.75rem;
  padding: 2px 8px;
  border-radius: 9999px;
  color: white;
}



.image-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #2A2A2E;
  padding: 8px;
  border-radius: 4px;
  font-size: 0.875rem;
  color: white;
}

.image-thumb {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 4px;
}

.image-info { flex: 1 1; }

.image-time {
  float: right;
  font-size: 0.75rem;
  color: #9CA3AF;
}

.image-meta {
  font-size: 0.75rem;
  color: #9CA3AF;
}
/* Container */
.viewer-container {
  display: flex;
  flex-direction: column;
  height: 10vh !important;
  width: 100%;
  margin: 2px;
}

/* Status Bar */
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.2rem;
  font-size: 0.rem;
  height: 0.5rem;
}

.status-items {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
}

.icon {
  width: 0.8rem;
  height: 0.8rem;
}

.green {
  color: #22c55e;
}

.yellow {
  color: #facc15;
}

.gray {
  color: #9ca3af;
}

.dot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background-color: currentColor;
}

.pulse {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.status-text {
  font-weight: 600;
}

/* Divider */
.divider {
  width: 1.5rem;
  height: 0.125rem;
  background-color: #6b7280;
}

/* Actions */
.actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.tat {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #d1d5db;
}

.clock-icon {
  width: 14px;
  height: 14px;
}

.tat-time {
  font-family: monospace;
}

/* Generate Button */
.generate-btn {
  background-color: #dc2626;
  color: white;
  padding: 0.300rem 0.50rem;
  font-size: 0.700rem;
  font-weight: 600;
  border-radius: 0.375rem;
  cursor: pointer;
  border: none;
}

.generate-btn:hover {
  background-color: #b91c1c;
}




.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin: 0;
  padding: 0.25rem 0;
  height: auto;
  flex-shrink: 0;
  align-items: flex-start; /* aligns button + dropdown properly */
}

.tool-btn {
  background-color: #dc2626;
  color: white;
  font-size: 0.750rem;
  padding: 0.10rem 0.25rem;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
}

.tool-btn:hover {
  background-color: #b91c1c;
}


 .measurement-dropdown {
  background-color: #dc2626;
  color: white;
  font-size: 0.700rem;
  padding: 0.10rem 0.25rem;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  width: 90px; 
  max-width: 100px;
  text-align: center;
}


.measurement-dropdown:hover {
  background-color: #b91c1c;
} 




#previewTab {
    display: grid; /* Use grid layout */
    grid-auto-flow: row; /* Flow items in rows (side by side) */
    grid-template-rows: repeat(auto-fill, minmax(100px, 1fr)); /* Set minimum and maximum width for grid items */
    grid-auto-rows: 100px; /* Force fixed column width for grid items */
    overflow-y: auto; /* Enable horizontal scrolling */
    border: 1px solid #007bff; /* Add border for visibility */
    padding: 0; /* Remove padding for no space */
    margin: 0; /* Ensure no margin */
    height: 400px;
      background: black;
  }


/* CKEditor Modal Styles */
.editor-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.editor-modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  height: 90%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.editor-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.editor-modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}

.close-editor-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-editor-btn:hover {
  background-color: #e0e0e0;
}

.editor-container {
  flex: 1 1;
  overflow: hidden;
  border-radius: 0 0 8px 8px;
}

/* Ensure CKEditor takes full space */
.ck.ck-editor {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ck.ck-editor__editable-container {
  flex: 1 1;
  overflow: auto;
}

.ck.ck-editor__editable {
  height: 100%;
  min-height: 400px;
}  



/* Split screen layout */
.main-content-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.main-content-area.split-view {
  display: flex;
  flex-direction: row;
  height: 100%;
}

/* Resize handle */
.resize-handle {
  width: 8px;
  background-color: #374151;
  cursor: col-resize;
  position: relative;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.resize-handle:hover,
.resize-handle.resizing {
  background-color: #ef4444;
}

.resize-handle::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 40px;
  background-color: #9ca3af;
  border-radius: 1px;
}

.resize-handle:hover::before,
.resize-handle.resizing::before {
  background-color: #ffffff;
}

/* Editor container */
.editor-container {
  display: flex;
  flex-direction: column;
  background: white;
  border-left: 1px solid #e5e7eb;
  height: 100%;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.editor-header h2 {
  margin: 0;
  color: #1f2937;
  font-size: 1rem;
  font-weight: 600;
}

.close-editor-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 0.25rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-editor-btn:hover {
  background-color: #e5e7eb;
  color: #374151;
}

/* CKEditor styles */
/* CKEditor Styles */
.document-editor {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid var(--ck-color-base-border);
  border-radius: var(--ck-border-radius);
  background: var(--ck-color-base-foreground);
}

.document-editor__toolbar {
  flex-shrink: 0;
  border-bottom: 1px solid var(--ck-color-toolbar-border);
  background: var(--ck-color-toolbar-background);
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  flex-wrap: wrap;
}

.document-editor__editable-container {
  flex-grow: 1;
  overflow: auto;
  background: white;
}

.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
  min-height: 400px;
  height: 100%;
  border: none;
  border-radius: 0;
}

.ck.ck-toolbar {
  border: none;
  background: transparent;
  flex-wrap: wrap;
}

/* Custom toolbar button styles */
.document-editor__toolbar button {
  margin: 2px;
  padding: 6px 12px;
  cursor: pointer;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  font-size: 12px;
  transition: background-color 0.2s;
}

.document-editor__toolbar button:hover {
  background: #0056b3;
}

.document-editor__toolbar select {
  margin: 2px;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 12px;
  background: white;
}

/* Editor container styles */
.editor-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  border-left: 1px solid #e0e0e0;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.editor-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}

.close-editor-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 5px;
  border-radius: 3px;
}

.close-editor-btn:hover {
  background: #e0e0e0;
  color: #333;
}

/* Resize handle styles */
.resize-handle {
  width: 8px;
  background: #e0e0e0;
  cursor: col-resize;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resize-handle:hover,
.resize-handle.resizing {
  background: #007bff;
}

.resize-handle::before {
  content: '';
  width: 2px;
  height: 40px;
  background: #999;
  border-radius: 1px;
}

.resize-handle:hover::before,
.resize-handle.resizing::before {
  background: white;
}


/* CKEditor List Styles */
.ck-content ol {
  list-style-type: decimal;
  padding-left: 2em;
}

.ck-content ul {
  list-style-type: disc;
  padding-left: 2em;
}

.ck-content ol ol {
  list-style-type: lower-latin;
}

.ck-content ul ul {
  list-style-type: circle;
}

.ck-content ol ul,
.ck-content ul ol {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.ck-content li {
  margin: 0.25em 0;
}

/* Ensure proper spacing in lists */
.ck-editor__editable ol,
.ck-editor__editable ul {
  margin: 1em 0;
  line-height: 1.6;
}

/* Fix for nested lists */
.ck-editor__editable ol ol,
.ck-editor__editable ul ul,
.ck-editor__editable ol ul,
.ck-editor__editable ul ol {
  margin: 0.5em 0;
}



/* Report Generation Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}


/* Toolbar Button Styles */
.toolbar-btn {
  margin: 5px;
  padding: 8px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.toolbar-dropdown {
  margin: 5px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
}

.finalize-report-btn {
  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;
  color: white !important;
  font-weight: 600 !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-size: 16px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  margin: 5px !important;
}

.finalize-report-btn:hover {
  background: linear-gradient(135deg, #4338ca, #2563eb) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
}

.user-name {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333;
  font-size: 14px;
  margin: 5px;
}

.current-user {
  font-weight: bold;
  color: #007bff;
}

/* CKEditor Custom Styles */
.document-editor {
  border: 1px solid #ddd;
  border-radius: 4px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.document-editor__toolbar {
  border-bottom: 1px solid #ddd;
  padding: 10px;
  background: #f8f9fa;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
}

.document-editor__editable-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

.ck-editor__editable {
  min-height: 500px;
  font-size: 14px;
  line-height: 1.6;
}

/* Resize Handle */
.resize-handle {
  width: 8px;
  background: #ddd;
  cursor: col-resize;
  transition: background 0.2s;
}

.resize-handle:hover,
.resize-handle.resizing {
  background: #007bff;
}

/* Editor Container */
.editor-container {
  background: white;
  border-left: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  background: #f8f9fa;
}

.close-editor-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  padding: 5px;
  border-radius: 4px;
}

.close-editor-btn:hover {
  background: #e9ecef;
  color: #495057;
}


/* Modal Styles for Popup Integration */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 90%;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.modal-body {
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
}

/* Form Styles */
.form-group {
  margin-bottom: 1rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
  margin: 2px;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* CKEditor Toolbar Styles */
.document-editor__toolbar {
  border: 1px solid #ccc;
  border-bottom: none;
  padding: 10px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.document-editor__editable-container {
  border: 1px solid #ccc;
  min-height: 500px;
}

.ck-editor__editable {
  min-height: 500px;
  padding: 15px;
  font-size: 14px;
  line-height: 1.6;
}

/* Toolbar Button Styles */
.report-here {
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  transition: all 0.2s ease;
}

.report-here:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.user-name {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  background: #e9ecef;
  border-radius: 4px;
  font-size: 14px;
}

/* Split Screen Styles */
.split-view {
  position: relative;
}

.resize-handle {
  width: 4px;
  background: #ccc;
  cursor: col-resize;
  transition: background 0.2s;
}

.resize-handle:hover,
.resize-handle.resizing {
  background: #007bff;
}

.editor-container {
  background: white;
  border-left: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
}

.editor-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
}

.close-editor-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-editor-btn:hover {
  background: #e9ecef;
  color: #495057;
}

/* Image container for report images */
.image-container {
  margin-top: 1rem;
  text-align: center;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  background: #f8f9fa;
}

.report-image {
  max-width: 100%;
  max-height: 300px;
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Error styles for form validation */
.err {
  border: 2px solid #dc3545 !important;
  background-color: #f8d7da !important;
}


/* Status bar improvements */
.status-bar {
  background: #1a1a1a;
  padding: 10px 20px;
  border-bottom: 1px solid #333;
}




`, "",{"version":3,"sources":["webpack://./src/pages/doctor/Viewer.css"],"names":[],"mappings":"AAAA;EACE,eAAe,OAAO,0BAA0B;EAChD,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB,MAAM,qBAAqB;EAC3C,aAAa,SAAS,mBAAmB;AAC3C;;;;AAIA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,SAAO;EACP,iBAAiB;AACnB;;;;AAIA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;;AAGA;EACE,aAAa,YAAY,mCAAmC;EAC5D,WAAW;EACX,uBAAuB;EACvB,QAAQ,iBAAiB,qCAAqC;EAC9D,uBAAuB;EACvB,mBAAmB,EAAE,kCAAkC;AACzD;;;;EAIE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;EACtB;AACF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,YAAY;GACX,cAAc;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,cAAc,YAAY,EAAE;AAC5B,YAAY,cAAc,EAAE;;AAE5B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB,OAAO,yCAAyC;EACjE,gBAAgB,SAAS,uCAAuC;EAChE,YAAY;EACZ,sBAAsB,GAAG,oBAAoB;EAC7C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,cAAc,SAAO,EAAE;;AAEvB;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;;;;AAKA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;CAGC;EACC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;AAC3B;;;;;AAKA;IACI,aAAa,EAAE,oBAAoB;IACnC,mBAAmB,EAAE,sCAAsC;IAC3D,yDAAyD,EAAE,iDAAiD;IAC5G,qBAAqB,EAAE,4CAA4C;IACnE,gBAAgB,EAAE,gCAAgC;IAClD,yBAAyB,EAAE,8BAA8B;IACzD,UAAU,EAAE,gCAAgC;IAC5C,SAAS,EAAE,qBAAqB;IAChC,aAAa;MACX,iBAAiB;EACrB;;;AAGF,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;;;AAIA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6CAA6C;EAC7C,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,uDAAuD;EACvD,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;;AAGA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;;;;EAIE,eAAe;AACjB;;;;AAIA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA,0BAA0B;AAC1B;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gEAAgE;EAChE,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qIAAqI;EACrI,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;;AAGA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":[".body {\n  position: fixed;      /* lock body in viewport */\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;     /* no x or y scroll */\n  display: flex;        /* flexbox layout */\n}\n\n\n\n.page-content {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex: 1;\n  background: black;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\n.report-type-dropdown-container {\n  display: flex;\n  height: 100px;\n  width: 100%;\n  flex: 1;\n  background: black;\n}\n\n\n\n.cornerstone-container {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  background: black;\n  height: 100%;\n}\n\n.clientcornerstone-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: black;\n  height: 100%;\n}\n\n.viewer-panel {\n  width: 100%;\n  margin:1px;\n}\n\n\n.viewport-div {\n  display: grid;           /* Grid container for all layouts */\n  width: 100%;\n  height: 90vh !important;\n  gap: 2px;                /* Optional space between viewports */\n  margin: 0.5em auto auto;\n  grid-auto-flow: row; /* ensures items fill rows first */\n}\n\n\n\n  #viewport2{\n    display: none;\n  }\n  \n  #viewport3{\n    display: none;\n  }\n  \n  #viewport4{\n    display: none;\n  }\n\n  .viewport {\n    width:auto;\n    height: 100%;\n    border: 2px solid red;\n    box-sizing: border-box;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    background-color: black;\n    margin: 1px;\n  }\n  \n  .cornerstone-canvas {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 100%;\n    max-height: 100%;\n    width: auto !important;\n    height: auto !important;\n    pointer-events: none;\n  }\n.viewer-sidebar {\n  max-width: 320px;\n  min-width: 150px;\n  background-color: #1D1D1F;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  height: 100%;\n  overflow: hidden;\n  color: white;\n   flex-shrink: 0;\n}\n\n.viewer-title {\n  font-size: 1.25rem;\n  font-weight: bold;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.white-text { color: white; }\n.red-text { color: #F87171; }\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n\n.user-avatar {\n  background-color: #6466F1;\n  border-radius: 9999px;\n  height: 36px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.user-mrn {\n  font-size: 0.75rem;\n  color: #9CA3AF;\n}\n\n.user-detail {\n  font-size: 0.75rem;\n  color: #9CA3AF;\n  margin-bottom: 0.2rem;\n}\n\n.history-notes {\n  max-height: 300px;      /* optional: minimum height if you want */\n  overflow-y: auto;        /* vertical scroll if content exceeds */\n  padding: 8px;\n  border: 1px solid #ddd;  /* optional border */\n  border-radius: 4px;\n  background-color: #2A2A2E;\n}\n\n/* Optional: smooth scroll for better UX */\n.history-notes::-webkit-scrollbar {\n  width: 6px;\n}\n\n.history-notes::-webkit-scrollbar-thumb {\n  background-color: #6466F1;\n  border-radius: 3px;\n}\n\n\n.history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.history-count {\n  background-color: #F87171;\n  font-size: 0.75rem;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  color: white;\n}\n\n.history-content {\n  background-color: #2A2A2E;\n  padding: 8px;\n  font-size: 0.7rem;\n  border-radius: 4px;\n  color: #D1D5DB;\n}\n\n.history-date {\n  text-transform: uppercase;\n  color: #9CA3AF;\n  margin-bottom: 2px;\n}\n\n.history-doctor {\n  color: #9CA3AF;\n}\n\n.history-text {\n  margin-top: 0.5rem;\n  color: white;\n}\n\n.images-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.images-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.images-count {\n  background-color: #F87171;\n  font-size: 0.75rem;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  color: white;\n}\n\n\n\n.image-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #2A2A2E;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  color: white;\n}\n\n.image-thumb {\n  width: 56px;\n  height: 56px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.image-info { flex: 1; }\n\n.image-time {\n  float: right;\n  font-size: 0.75rem;\n  color: #9CA3AF;\n}\n\n.image-meta {\n  font-size: 0.75rem;\n  color: #9CA3AF;\n}\n/* Container */\n.viewer-container {\n  display: flex;\n  flex-direction: column;\n  height: 10vh !important;\n  width: 100%;\n  margin: 2px;\n}\n\n/* Status Bar */\n.status-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0.2rem;\n  font-size: 0.rem;\n  height: 0.5rem;\n}\n\n.status-items {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n}\n\n.icon {\n  width: 0.8rem;\n  height: 0.8rem;\n}\n\n.green {\n  color: #22c55e;\n}\n\n.yellow {\n  color: #facc15;\n}\n\n.gray {\n  color: #9ca3af;\n}\n\n.dot {\n  width: 0.75rem;\n  height: 0.75rem;\n  border-radius: 50%;\n  background-color: currentColor;\n}\n\n.pulse {\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.status-text {\n  font-weight: 600;\n}\n\n/* Divider */\n.divider {\n  width: 1.5rem;\n  height: 0.125rem;\n  background-color: #6b7280;\n}\n\n/* Actions */\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.tat {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: #d1d5db;\n}\n\n.clock-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.tat-time {\n  font-family: monospace;\n}\n\n/* Generate Button */\n.generate-btn {\n  background-color: #dc2626;\n  color: white;\n  padding: 0.300rem 0.50rem;\n  font-size: 0.700rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  border: none;\n}\n\n.generate-btn:hover {\n  background-color: #b91c1c;\n}\n\n\n\n\n.toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin: 0;\n  padding: 0.25rem 0;\n  height: auto;\n  flex-shrink: 0;\n  align-items: flex-start; /* aligns button + dropdown properly */\n}\n\n.tool-btn {\n  background-color: #dc2626;\n  color: white;\n  font-size: 0.750rem;\n  padding: 0.10rem 0.25rem;\n  border-radius: 0.25rem;\n  border: none;\n  cursor: pointer;\n}\n\n.tool-btn:hover {\n  background-color: #b91c1c;\n}\n\n\n .measurement-dropdown {\n  background-color: #dc2626;\n  color: white;\n  font-size: 0.700rem;\n  padding: 0.10rem 0.25rem;\n  border-radius: 0.25rem;\n  border: none;\n  cursor: pointer;\n  width: 90px; \n  max-width: 100px;\n  text-align: center;\n}\n\n\n.measurement-dropdown:hover {\n  background-color: #b91c1c;\n} \n\n\n\n\n#previewTab {\n    display: grid; /* Use grid layout */\n    grid-auto-flow: row; /* Flow items in rows (side by side) */\n    grid-template-rows: repeat(auto-fill, minmax(100px, 1fr)); /* Set minimum and maximum width for grid items */\n    grid-auto-rows: 100px; /* Force fixed column width for grid items */\n    overflow-y: auto; /* Enable horizontal scrolling */\n    border: 1px solid #007bff; /* Add border for visibility */\n    padding: 0; /* Remove padding for no space */\n    margin: 0; /* Ensure no margin */\n    height: 400px;\n      background: black;\n  }\n\n\n/* CKEditor Modal Styles */\n.editor-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.editor-modal-content {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  height: 90%;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.editor-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.editor-modal-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.5rem;\n}\n\n.close-editor-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 5px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.close-editor-btn:hover {\n  background-color: #e0e0e0;\n}\n\n.editor-container {\n  flex: 1;\n  overflow: hidden;\n  border-radius: 0 0 8px 8px;\n}\n\n/* Ensure CKEditor takes full space */\n.ck.ck-editor {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.ck.ck-editor__editable-container {\n  flex: 1;\n  overflow: auto;\n}\n\n.ck.ck-editor__editable {\n  height: 100%;\n  min-height: 400px;\n}  \n\n\n\n/* Split screen layout */\n.main-content-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-content-area.split-view {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n/* Resize handle */\n.resize-handle {\n  width: 8px;\n  background-color: #374151;\n  cursor: col-resize;\n  position: relative;\n  transition: background-color 0.2s;\n  flex-shrink: 0;\n}\n\n.resize-handle:hover,\n.resize-handle.resizing {\n  background-color: #ef4444;\n}\n\n.resize-handle::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 2px;\n  height: 40px;\n  background-color: #9ca3af;\n  border-radius: 1px;\n}\n\n.resize-handle:hover::before,\n.resize-handle.resizing::before {\n  background-color: #ffffff;\n}\n\n/* Editor container */\n.editor-container {\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-left: 1px solid #e5e7eb;\n  height: 100%;\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.editor-header h2 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.close-editor-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  padding: 0.25rem;\n  border-radius: 0.375rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-editor-btn:hover {\n  background-color: #e5e7eb;\n  color: #374151;\n}\n\n/* CKEditor styles */\n/* CKEditor Styles */\n.document-editor {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  border: 1px solid var(--ck-color-base-border);\n  border-radius: var(--ck-border-radius);\n  background: var(--ck-color-base-foreground);\n}\n\n.document-editor__toolbar {\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--ck-color-toolbar-border);\n  background: var(--ck-color-toolbar-background);\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  flex-wrap: wrap;\n}\n\n.document-editor__editable-container {\n  flex-grow: 1;\n  overflow: auto;\n  background: white;\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n  min-height: 400px;\n  height: 100%;\n  border: none;\n  border-radius: 0;\n}\n\n.ck.ck-toolbar {\n  border: none;\n  background: transparent;\n  flex-wrap: wrap;\n}\n\n/* Custom toolbar button styles */\n.document-editor__toolbar button {\n  margin: 2px;\n  padding: 6px 12px;\n  cursor: pointer;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 3px;\n  font-size: 12px;\n  transition: background-color 0.2s;\n}\n\n.document-editor__toolbar button:hover {\n  background: #0056b3;\n}\n\n.document-editor__toolbar select {\n  margin: 2px;\n  padding: 6px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 12px;\n  background: white;\n}\n\n/* Editor container styles */\n.editor-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: white;\n  border-left: 1px solid #e0e0e0;\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.editor-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.5rem;\n}\n\n.close-editor-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 5px;\n  border-radius: 3px;\n}\n\n.close-editor-btn:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n/* Resize handle styles */\n.resize-handle {\n  width: 8px;\n  background: #e0e0e0;\n  cursor: col-resize;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.resize-handle:hover,\n.resize-handle.resizing {\n  background: #007bff;\n}\n\n.resize-handle::before {\n  content: '';\n  width: 2px;\n  height: 40px;\n  background: #999;\n  border-radius: 1px;\n}\n\n.resize-handle:hover::before,\n.resize-handle.resizing::before {\n  background: white;\n}\n\n\n/* CKEditor List Styles */\n.ck-content ol {\n  list-style-type: decimal;\n  padding-left: 2em;\n}\n\n.ck-content ul {\n  list-style-type: disc;\n  padding-left: 2em;\n}\n\n.ck-content ol ol {\n  list-style-type: lower-latin;\n}\n\n.ck-content ul ul {\n  list-style-type: circle;\n}\n\n.ck-content ol ul,\n.ck-content ul ol {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\n.ck-content li {\n  margin: 0.25em 0;\n}\n\n/* Ensure proper spacing in lists */\n.ck-editor__editable ol,\n.ck-editor__editable ul {\n  margin: 1em 0;\n  line-height: 1.6;\n}\n\n/* Fix for nested lists */\n.ck-editor__editable ol ol,\n.ck-editor__editable ul ul,\n.ck-editor__editable ol ul,\n.ck-editor__editable ul ol {\n  margin: 0.5em 0;\n}\n\n\n\n/* Report Generation Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.close-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #333;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n/* Toolbar Button Styles */\n.toolbar-btn {\n  margin: 5px;\n  padding: 8px 12px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.toolbar-dropdown {\n  margin: 5px;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  background: white;\n}\n\n.finalize-report-btn {\n  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;\n  color: white !important;\n  font-weight: 600 !important;\n  border: none !important;\n  border-radius: 12px !important;\n  padding: 12px 24px !important;\n  font-size: 16px !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  margin: 5px !important;\n}\n\n.finalize-report-btn:hover {\n  background: linear-gradient(135deg, #4338ca, #2563eb) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;\n}\n\n.user-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #333;\n  font-size: 14px;\n  margin: 5px;\n}\n\n.current-user {\n  font-weight: bold;\n  color: #007bff;\n}\n\n/* CKEditor Custom Styles */\n.document-editor {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.document-editor__toolbar {\n  border-bottom: 1px solid #ddd;\n  padding: 10px;\n  background: #f8f9fa;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px;\n}\n\n.document-editor__editable-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.ck-editor__editable {\n  min-height: 500px;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* Resize Handle */\n.resize-handle {\n  width: 8px;\n  background: #ddd;\n  cursor: col-resize;\n  transition: background 0.2s;\n}\n\n.resize-handle:hover,\n.resize-handle.resizing {\n  background: #007bff;\n}\n\n/* Editor Container */\n.editor-container {\n  background: white;\n  border-left: 1px solid #ddd;\n  display: flex;\n  flex-direction: column;\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #ddd;\n  background: #f8f9fa;\n}\n\n.close-editor-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6c757d;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.close-editor-btn:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n\n/* Modal Styles for Popup Integration */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.modal-content {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  max-width: 90%;\n  max-height: 80vh;\n  overflow: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #dee2e6;\n  background: #f8f9fa;\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.modal-body {\n  padding: 1rem;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  cursor: pointer;\n  margin: 2px;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n/* CKEditor Toolbar Styles */\n.document-editor__toolbar {\n  border: 1px solid #ccc;\n  border-bottom: none;\n  padding: 10px;\n  background: #f5f5f5;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.document-editor__editable-container {\n  border: 1px solid #ccc;\n  min-height: 500px;\n}\n\n.ck-editor__editable {\n  min-height: 500px;\n  padding: 15px;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* Toolbar Button Styles */\n.report-here {\n  padding: 8px 16px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.report-here:hover {\n  background: #0056b3;\n  transform: translateY(-1px);\n}\n\n.user-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 5px 10px;\n  background: #e9ecef;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Split Screen Styles */\n.split-view {\n  position: relative;\n}\n\n.resize-handle {\n  width: 4px;\n  background: #ccc;\n  cursor: col-resize;\n  transition: background 0.2s;\n}\n\n.resize-handle:hover,\n.resize-handle.resizing {\n  background: #007bff;\n}\n\n.editor-container {\n  background: white;\n  border-left: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n}\n\n.editor-header {\n  padding: 15px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n}\n\n.close-editor-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6c757d;\n  padding: 5px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-editor-btn:hover {\n  background: #e9ecef;\n  color: #495057;\n}\n\n/* Image container for report images */\n.image-container {\n  margin-top: 1rem;\n  text-align: center;\n  padding: 10px;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  background: #f8f9fa;\n}\n\n.report-image {\n  max-width: 100%;\n  max-height: 300px;\n  border-radius: 0.25rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n/* Error styles for form validation */\n.err {\n  border: 2px solid #dc3545 !important;\n  background-color: #f8d7da !important;\n}\n\n\n/* Status bar improvements */\n.status-bar {\n  background: #1a1a1a;\n  padding: 10px 20px;\n  border-bottom: 1px solid #333;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
